// فیلترِ جست‌وجوی AntD Select برای گزینه‌هایی که با <Option> نوشته شده‌اند.
//
// گاتچا: در `<Option>{name} ({code})</Option>` مقدارِ `option.children` یک **آرایه**
// است (`[name, " (", code, ")"]`) نه رشته؛ پس `option.children.toLowerCase()` هرگز
// match نمی‌شود و لیست با اولین حرفِ تایپ‌شده کاملاً خالی می‌ماند.
// این هلپر children را به متن تخت تبدیل می‌کند و ارقام فارسی/عربی را هم یکدست می‌کند
// تا جست‌وجوی کدِ پرسنلی با هر دو نوع رقم کار کند.
import { toEnglishDigits } from "./digitNormalizer";

/** children (رشته | عدد | آرایه‌ی تودرتو) → متنِ تخت */
export function optionText(children) {
  if (children === null || children === undefined || children === false) return "";
  if (Array.isArray(children)) return children.map(optionText).join("");
  if (typeof children === "object") return optionText(children.props?.children);
  return String(children);
}

const norm = (s) => toEnglishDigits(String(s ?? "")).toLowerCase().trim();

/**
 * متنِ قابلِ جست‌وجوی یک گزینه — با **هر دو** شکلِ نوشتنِ Select کار می‌کند.
 *
 * 🐞 گاتچای دومی که گران تمام شد: این هلپر فقط `option.children` را می‌خواند،
 * ولی Selectهایی که گزینه را با پراپِ `options={[{value, label}]}` می‌دهند
 * اصلاً `children` ندارند ⇒ متن `""` می‌شد و **با اولین حرفِ تایپ‌شده لیست
 * کاملاً خالی می‌ماند**. کاربر گزارش داد «تو مساعده نفرات را سرچ می‌کنم
 * نمی‌آورد»؛ همین اشکال در بیمه و گریدِ هفتگی هم بود.
 * (`optionFilterProp` هم نجات نمی‌داد: وجودِ `filterOption` صریح بر آن مقدم است.)
 */
export function searchableText(option) {
  if (!option) return "";
  const parts = [
    optionText(option.children),
    typeof option.label === "object" ? optionText(option.label) : option.label,
    option.title,
    // مقدارِ عددی (id) عمداً نمی‌آید؛ فقط اگر رشته باشد (مثلِ کدِ پرسنلی)
    typeof option.value === "string" ? option.value : "",
  ];
  return parts.filter(Boolean).join(" ");
}

/**
 * filterOption برای Selectها — چه با <Option> نوشته شده باشند چه با options.
 *
 * 🐞 گزینه‌های **گروه‌بندی‌شده**: rc-select اول خودِ گروه را با همین تابع تست
 * می‌کند و اگر بخورد، **کلِ فرزندانش را بدونِ فیلتر** نشان می‌دهد. با گروهی به
 * نامِ «پرتکرار»، تایپ‌کردنِ «پ» یا «ر» یا «ت» جست‌وجو را عملاً خاموش می‌کرد.
 * گروه هیچ‌وقت خودش تطبیق نمی‌دهد؛ فقط فرزندانش.
 */
export const filterByChildren = (input, option) => {
  if (option && Array.isArray(option.options)) return false;   // گرهِ گروه
  return norm(searchableText(option)).includes(norm(input));
};

export default filterByChildren;
